import { useSelector } from "react-redux";
import ChatState from "../../../components/chat/chatState/ChatState";
import DisplayContainer from "../../../components/displayContainer/DisplayContainer";
import SupportTicketsSidebarIcon from "../../../components/icons/SupportTicketsSidebarIcon";
import TextWrapper from "../../../components/textWrapper/TextWrapper";
import TicketList from "./ticketList/TicketList";
import TicketWindow from "./ticketWindow/TicketWindow";
import styles from "./supportTickets.module.css";

// تذاكر الدعم: the queue on the left, the open ticket on the right. A ticket
// stays open when the filters leave it out of the list.
const SupportTickets = () => {
  const hasOpenTicket = useSelector((state) => Boolean(state.supportTickets.activeTicketId));

  return (
    <div className={styles.container}>
      <TextWrapper textStyle="textTitle">تذاكر الدعم</TextWrapper>
      <div className={styles.displayContainerWrapper}>
        <DisplayContainer className={styles.panel}>
          <div className={styles.shell}>
            <aside className={styles.listPane} dir="rtl">
              <TicketList />
            </aside>
            <section className={styles.windowPane} dir="rtl">
              {hasOpenTicket ? (
                <TicketWindow />
              ) : (
                <ChatState
                  icon={<SupportTicketsSidebarIcon />}
                  title="اختر تذكرة"
                  text="اختر تذكرة من القائمة لقراءة رسائلها والرد على اللاعب."
                />
              )}
            </section>
          </div>
        </DisplayContainer>
      </div>
    </div>
  );
};

export default SupportTickets;
